export const numberFormatter = new Intl.NumberFormat('en-GB', {
    style: 'decimal'
});
